<!-- 活动-我的点赞 -->
<template>
	<div class="wrap">

		<div class="header">
			<img src="../assets/return.png" class="return-img" @click="$router.back()">
			<p class="header-title">我的点赞</p>
		</div>

		<div class="module">
      <van-list
          style="width: 100%"
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :finished-text="list.length > 0 ? '没有更多了' : ''"
          @load="getList"
      >
        <ul class="list">
          <template v-for="(item, index) in list">
            <p class="module-time">{{ item.create_at }}</p>
            <li @click.stop="toDetail(item)">
              <img :src="item.cover_arr[0]" class="img">
              <div class="item-sidebar">
                <p class="item-name">{{ item.title }}</p>
                <p class="item-msg">{{ item.address }} · {{ item.start_time }} - {{ item.end_time }}</p>
                <ul class="tag-list">
                  <li v-for="(item2, index2) in item.label_name" :key="index2">{{ item2 }}</li>
                </ul>
                <div class="item-between">
                  <span class="price">¥{{ item.price }}起</span>
                </div>
              </div>
            </li>
          </template>
          <!-- 暂无数据展示 -->
          <div class="normal-box-small" v-if="list.length === 0">
            <img src="../assets/normal.png">
            暂无数据
          </div>
        </ul>
      </van-list>
		</div>

	</div>
</template>

<script>
	import {ActivityService} from "@/common/service";
  import {Toast} from "vant";

  export default {
		components: {},
    data() {
      return {
        params: {
          title: '',  // 标题
          page: 1,  // 页数
          page_num: 10,  // 每页数
        },
        list: [],
        loading: false,
        finished: false,
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      toDetail(item) {
        if (item.is_normal === 0) return Toast('已下架');
        this.$router.push(`/activity-sign-up?activity_id=${item.activity_id}`);
      },
      getList() {
        this.loading = true;
        ActivityService.getTagsActivity(this.params)
            .then(({ data }) => {
              const list = data.list;
              this.list = this.params.page === 1 ? list : [...this.list, ...list];
              if (list.length < this.params.page_num) {
                this.finished = true;
              } else {
                this.params.page++;
              }
            }).finally(() => {
          this.loading = false;
          this.refreshLoading = false;
        }).catch(() => this.finished = true);
      },
    }
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		min-height: 100vh;
		background: linear-gradient(180deg, #FFFFFF, #F3F3F3);
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 44px 0 0;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		background-color: #FFFFFF;
		z-index: 999;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight:bold;
	}

	.module {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.module-time {
		width: 100%;
		height: 38px;
		line-height: 38px;
		color: #7F7F7F;
		font-size: 10px;
	}

	.list {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.list>li {
		width: 100%;
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
		border-radius: 12px;
		margin-bottom: 12px;
		padding: 10px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
	}

	.img {
		width: 120px;
		height: 110px;
		border-radius: 10px;
		margin-right: 10px;
		object-fit: cover;
	}

	.item-sidebar {
		flex: 1;
		min-height: 100px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.item-name {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		line-height: 21px;
		color: #222222;
		font-size: 15px;
	}

	.item-msg {
		width: 100%;
		color: #666666;
		font-size: 10px;
	}

  .tag-list {
    width: 100%;
    height: 36px;
    overflow: hidden;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .tag-list>li {
    color: #2A63F3;
    font-size: 9px;
    padding: 0 4px;
    width: fit-content;
    height: 14px;
    line-height: 14px;
    border-radius: 3px;
    background-color: #F3F3F3;
    display: flex;
    align-items: center;
    margin: 2px 3px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; /*这里设置几行*/
    overflow: hidden;
  }

	.item-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}

	.price {
		color: #FF2828;
		font-size: 14px;
		font-weight: bold;
	}

	.btn {
		color: #FFFFFF;
		font-size: 12px;
		height: 24px;
		line-height: 24px;
		display: flex;
		align-items: center;
		background-color: #2A63F3;
		width: fit-content;
		padding: 0 11px;
		border-radius: 30px;
	}

	.normal-box-small {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 14px;
		color: #999992;
		padding: 120px 0;
	}

	.normal-box-small>img {
		width: 150px;
		margin-bottom: 9px;
	}
</style>
